import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

export default function Paginator({
  pagination,
  range,
  setPage,
  setPagination,
}) {
  const [pageList, setPageList] = useState([]);

  useEffect(() => {
    const paginationArray = [];
    if (pagination.currentPage - range > 1) {
      paginationArray.push(["...", pagination.currentPage, -1]);
    }

    for (
      let i = pagination.currentPage - range;
      i <= pagination.currentPage + range;
      i++
    ) {
      if (i > 0 && i <= pagination.totalPages) {
        paginationArray.push([i, i, i]);
      }
    }

    // Add ellipsis if there are more pages after the range
    if (pagination.currentPage + range < pagination.totalPages) {
      paginationArray.push(["...", pagination.currentPage, -1]);
    }
    setPageList(paginationArray);
  }, [pagination, range]);

  // Check if the component should be disabled
  if (pagination.currentPage === null || pagination.totalPages === null) {
    return null; // Don't render anything if disabled
  }

  return (
    <>
      {pageList.length > 0 && (
        <nav
          aria-label="Page navigation example"
          className="d-flex justify-content-end mr-4"
        >
          <ul className="pagination ml-auto">
            <li className="page-item">
              <button
                className="page-link"
                disabled={pagination.currentPage <= 1}
                onClick={(e) => {
                  e.preventDefault();
                  setPage(pagination.currentPage - 1);
                }}
              >
                Previous
              </button>
            </li>
            {pageList.map((value, index) => (
              <li
                className={`page-item ${
                  pagination.currentPage === value[2] ? "active" : ""
                }`}
                key={index}
                onClick={(e) => {
                  e.preventDefault();
                  setPage(value[1]);
                }}
              >
                <button className="page-link">{value[0]}</button>
              </li>
            ))}

            <li className="page-item">
              <button
                className="page-link"
                disabled={pagination.currentPage >= pagination.totalPages}
                onClick={(e) => {
                  e.preventDefault();
                  setPage(pagination.currentPage + 1);
                }}
              >
                Next
              </button>
            </li>
          </ul>
          <ul className="pagination ms-2">
            <li className="page-item">
              <select
                className="form-control"
                onChange={(e) => {
                  setPagination((prevValue) => ({
                    ...prevValue,
                    size: +e.target.value,
                  }));
                  setPage(1);
                }}
                defaultValue="10" // Set the default selected value
              >
                <option value="10">10</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="250">250</option>
                <option value="500">500</option>
                <option value="1000">1000</option>
              </select>
            </li>
            <li className="page-item ms-2">
              <input
                type="text"
                name=""
                id=""
                className="form-control"
                disabled
                value={`Total Records: ${pagination.totalItems}`}
              />
            </li>
            <li className="page-item ms-2">
              <input
                type="text"
                name=""
                id=""
                className="form-control"
                disabled
                value={`Total Pages: ${pagination.totalPages}`}
              />
            </li>
            <li className="page-item ms-2 d-flex">
              <input
                type="number"
                name=""
                min={1}
                id="pageNumberInput"
                className="form-control"
                placeholder="Page number"
              />
              <button
                type="button"
                className="btn btn-primary btn-sm ms-2 "
                onClick={() => {
                  const inputElement =
                    document.getElementById("pageNumberInput");
                  if (inputElement.value === "") {
                    alert("Enter page number");
                    return;
                  }
                  const inputValue = inputElement
                    ? Number(inputElement.value)
                    : 1;
                  if (inputValue < 1) {
                    alert("Invalid page number");
                    if (inputElement) inputElement.value = "";
                    return;
                  }
                  if (pagination.totalPages < inputValue) {
                    alert("Invalid page number");
                    if (inputElement) inputElement.value = "";
                    return;
                  }
                  setPage(inputValue);
                  if (inputElement) inputElement.value = "";
                }}
              >
                Go{" "}
              </button>
            </li>
          </ul>
        </nav>
      )}
    </>
  );
}

Paginator.propTypes = {
  pagination: PropTypes.shape({
    currentPage: PropTypes.number,
    totalPages: PropTypes.number,
    totalItems: PropTypes.number,
  }),
  range: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  setPagination: PropTypes.func.isRequired,
};
